import { BlockStack, InlineGrid, Text, SkeletonBodyText, SkeletonDisplayText, DataTable, Divider, InlineStack, Button } from '@shopify/polaris';
import { useGetVehiclelog, useMutateCreatePassengerListing, useMutateDeleteVehiclelog, useMutateTripLogListing } from 'queries/vehicle_log.query';
import { useParams } from 'react-router-dom';
import dateandtime from 'date-and-time';
import __helpers from 'helpers/index';
import { DeleteIcon, EditIcon, PageDownIcon } from '@shopify/polaris-icons';
import { useNotification } from 'context/NotificationContext';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import { useCallback, useRef, useState } from 'react';
import ListLogEditModal from './list_log.edit.modal';
import { ENUM_INVOICE_STATUS } from 'queries/invoices.query';

export default function ListLogDetail() {
  const REACT_APP_AJAX_UPLOAD_PERMALINK = process.env.REACT_APP_AJAX_UPLOAD_PERMALINK;
  const [showModal, setShowModal] = useState(false);
  const [currentLogId, setCurrentLogId] = useState<string>(null);

  let { vehicle_log_id, vehicle_id } = useParams();
  const { data: vehicleLogData, isLoading: loadingVehicleLogData } = useGetVehiclelog(vehicle_log_id);
  /** Xóa thì hỏi  */
  const { showDeleteConfirm } = useDeleteConfirm();
  const { mutateAsync: deleteVehicleLog } = useMutateDeleteVehiclelog();
  const deleteVehicleLogCallback = useCallback(
    async (vehicle_log_id: any) => {
      let confirmCancelTicket = await showDeleteConfirm('Bạn có chắc muốn xóa?', `Đây là việc không thể hoàn tác, vui lòng thao tác cẩn thận.`);
      try {
        if (confirmCancelTicket) await deleteVehicleLog(vehicle_log_id);
      } catch (e) {}
    },
    [deleteVehicleLog, showDeleteConfirm]
  );

  /** Tạo  */
  /* End form */
  const { addNotification } = useNotification();
  const currentVehicleLogCreatingPDFPassengerListing = useRef(null);
  const currentVehicleLogCreatingVehicleLogPDF = useRef(null);
  const { mutateAsync: createPassengerListing, isPending: creatingPassengerListing } = useMutateCreatePassengerListing();
  const createPassengerListingCallback = useCallback(async (trip_manifest_id) => {
    try {
      await createPassengerListing(trip_manifest_id);
      addNotification('info', 'Tạo bảng kê khách thành công! Vui lòng chờ vài giây để hệ thống tạo file và cập nhật link tải về.');
    } catch (e) {
      addNotification('error', 'Không thể tạo bảng kê khách!');
    }
  }, []);

  const { mutateAsync: createTriplog, isPending: creatingTriplog } = useMutateTripLogListing();
  const createTripLogCallback = useCallback(async (trip_manifest_id) => {
    try {
      await createTriplog(trip_manifest_id);
      addNotification('info', 'Tạo nhật trình thành công, đợi một tới hai giây để hệ thống tạo file PDF.');
    } catch (e) {
      addNotification('error', 'Không thể tạo nhật trình!');
    }
  }, []);

  return (
    <div className="ABCDEFGH">
      {loadingVehicleLogData ? (
        <BlockStack gap="400">
          <SkeletonDisplayText />
          <SkeletonBodyText />
          <SkeletonBodyText />
          <SkeletonBodyText />
        </BlockStack>
      ) : null}

      <InlineGrid gap={'200'} columns={['oneThird', 'twoThirds']}>
        <BlockStack gap="200">
          <Text as="h3" variant="headingLg">
            {vehicleLogData?.title}
          </Text>
          <br />
          <BlockStack gap={'200'}>
            <Text as="p">Loại di chuyển {vehicleLogData?.trip_type}</Text>
            <Text as="p">Doanh thu {__helpers.formatNumberWithCommas(vehicleLogData?.trip_manifest?.total_fare || 0)}</Text>
            <Text as="p">Khoảng cách {vehicleLogData?.distance} KM</Text>
            <Text as="p">Ngày di chuyển {dateandtime.format(new Date(Number(vehicleLogData?.createdAt)), 'DD/MM/YYYY')}</Text>

            <Text as="p">
              Đi từ {vehicleLogData?.start_address} lúc {vehicleLogData?.start_time}{' '}
            </Text>
            <Text as="p">
              Đến {vehicleLogData?.end_address} lúc {vehicleLogData?.end_time}
            </Text>
          </BlockStack>
          <br />
          <Text as="h4" variant="headingMd">
            Thông tin xe
          </Text>
          <br />
          <BlockStack gap="200">
            <Text as="p">
              Loại xe {vehicleLogData?.vehicle_data?.name}, biển số {vehicleLogData?.vehicle_data?.license_plate}
            </Text>
          </BlockStack>
          <br />
          <Text as="h4" variant="headingMd">
            Thông tin tài xế
          </Text>
          <br />
          {vehicleLogData?.driver_data ? (
            <Text as="p">
              {vehicleLogData?.driver_data?.display_name}, ID {vehicleLogData?.driver_data?.user_id}
            </Text>
          ) : (
            <Text as="p" tone="subdued">
              Chưa có thông tin tài xế
            </Text>
          )}
          <Divider />
          <InlineStack gap="200">
            {vehicleLogData?.file_passenger_listing ? (
              <Button
                variant="plain"
                icon={PageDownIcon}
                tone="success"
                url={`${REACT_APP_AJAX_UPLOAD_PERMALINK}/${vehicleLogData?.file_passenger_listing}`}
                target="_blank"
              >
                Tải xuống bảng kê
              </Button>
            ) : (
              <Button
                variant="plain"
                icon={PageDownIcon}
                loading={creatingPassengerListing && currentVehicleLogCreatingPDFPassengerListing.current === vehicleLogData?.id}
                onClick={() => {
                  currentVehicleLogCreatingPDFPassengerListing.current = vehicleLogData?.id;
                  createPassengerListingCallback(vehicleLogData?.id);
                }}
              >
                Tạo bảng kê khách
              </Button>
            )}
            {vehicleLogData?.file_trip_log ? (
              <Button
                variant="plain"
                icon={PageDownIcon}
                size="medium"
                tone="success"
                url={`${REACT_APP_AJAX_UPLOAD_PERMALINK}/${vehicleLogData?.file_trip_log}`}
                target="_blank"
              >
                Tải nhật trình
              </Button>
            ) : (
              <Button
                variant="plain"
                icon={PageDownIcon}
                loading={creatingTriplog && currentVehicleLogCreatingVehicleLogPDF.current === vehicleLogData?.id}
                onClick={() => {
                  currentVehicleLogCreatingVehicleLogPDF.current = vehicleLogData?.id;
                  createTripLogCallback(vehicleLogData?.id);
                }}
              >
                Tạo nhật trình
              </Button>
            )}

            <Button
              variant="plain"
              icon={DeleteIcon}
              onClick={() => {
                deleteVehicleLogCallback(vehicleLogData?.id);
              }}
            >
              Xóa
            </Button>
            <Button
              variant="plain"
              icon={EditIcon}
              onClick={() => {
                setCurrentLogId(vehicleLogData?.id);
                setShowModal(true);
              }}
            >
              Chỉnh
            </Button>
          </InlineStack>
          <br />
        </BlockStack>
        <div className="">
          <Text as="h3" variant="headingLg">
            Danh sách vé
          </Text>
          <br />

          {vehicleLogData?.trip_manifest?.trip_manifest_ticket ? (
            <DataTable
              hideScrollIndicator
              columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'numeric']}
              headings={['STT', 'Mã đơn hàng', 'Hành khách', 'Đơn vị', 'Đón tại', 'Trả tại', 'Giá vé']}
              rows={vehicleLogData?.trip_manifest?.trip_manifest_ticket.map((ticketElement, index) => {
                return [
                  index,
                  ticketElement?.ticket?.orders?.order_code,
                  ticketElement?.ticket?.orders?.customer_data?.display_name,
                  ticketElement?.ticket?.ticket_type,
                  ticketElement?.ticket?.orders?.pickup_address,
                  ticketElement?.ticket?.orders?.dropoff_address,
                  __helpers.formatNumberWithCommas(ticketElement?.ticket?.price || 0),
                ];
              })}
            />
          ) : (
            <Text as="p" variant="headingMd" tone="subdued">
              Không có khách nào trong chuyến này!
            </Text>
          )}

          <br />
          <Divider />
          <br />

          <Text as="h3" variant="headingLg">
            Danh sách hóa đơn
          </Text>
          <br />
          {vehicleLogData?.trip_manifest?.trip_manifest_invoice ? (
            <DataTable
              columnContentTypes={['text', 'numeric', 'text', 'numeric', 'numeric', 'numeric', 'numeric']}
              headings={['STT', 'Số hóa đơn', 'Viết cho', 'Giá trị', 'Thuế', 'Tổng', 'Tình trạng']}
              rows={vehicleLogData?.trip_manifest?.trip_manifest_invoice.map((A, index) => {
                const invoiceData = A.invoices;

                return [
                  index,
                  invoiceData.shDon,
                  invoiceData?.NMua_Ten || invoiceData?.NMua_HVTNMHang,
                  invoiceData.TgTTTBSo,
                  invoiceData.TgTThue,
                  invoiceData.TgThTien,
                  invoiceData.invoice_status === ENUM_INVOICE_STATUS.CANCEL ? 'ĐÃ HỦY' : invoiceData?.signed_data ? 'Đã ký' : 'Chưa ký',
                ];
              })}
            />
          ) : (
            <Text as="p" variant="headingMd" tone="subdued">
              Không có hóa đơn nào trong chuyến này!
            </Text>
          )}
        </div>
      </InlineGrid>

      <ListLogEditModal
        show={showModal}
        vehicle_id={vehicle_id}
        currentLogId={currentLogId}
        onClose={() => {
          setShowModal(false);
          setCurrentLogId(null);
        }}
      />
    </div>
  );
}

